import cx from 'classnames'
import * as React from 'react'

import { arrowLeft } from '../../icons'
import type { PageLoginViewModel } from '../../modules/Navigation/view-models/PageLoginViewModel'
import type { BreakingNewsItemViewModel } from '../../view-models/BreakingNewsItemViewModel'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import type { MobileMenuViewModel } from '../../view-models/MobileMenuViewModel'
import type { NavigationLogoViewModel } from '../../view-models/NavigationLogoViewModel'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import type { ServiceMenuViewModel } from '../../view-models/ServiceMenuViewModel'
import DividerComp from '../DividerComp/DividerComp'
import HeaderMobile from '../HeaderMobile/HeaderMobile'
import Icon from '../Icon/Icon'
import Link from '../Link/Link'
import NewsTicker from '../NewsTicker/NewsTicker'
import SideMenuMobile from '../SideMenuMobile/SideMenuMobile'
import styles from './navigationMobile-style.css'

type Props = {
  logo: NavigationLogoViewModel
  pageLogin?: PageLoginViewModel
  mobileMenuItems: MobileMenuViewModel
  serviceMenu?: ServiceMenuViewModel
  searchBtn?: SearchBarViewModel
  backLink?: LinkViewModel
  items?: Array<BreakingNewsItemViewModel>
  header?: string
  hide?: boolean | null
  breakingNewsLink?: LinkViewModel
  notificationCount?: string
  myPageLink?: LinkViewModel
  onSubmit?: (...args: Array<any>) => any
  alignLogin?: 'right'| 'left'
  onCloseHeaderOverlay?: () => void
  pageLinks?: Array<LinkViewModel>
}
type State = {
  isOpen: boolean
  currentLinksOpen: boolean
  mobileCurrentItems: Array<any>
}

class NavigationMobile extends React.Component<Props, State> {
  static displayName = 'NavigationMobile'
  static defaultProps = {}
  state = {
    isOpen: false,
    currentLinksOpen: false,
    mobileCurrentItems: [],
  }

  componentDidMount(): void {
    if (this.props.mobileMenuItems) {
      const { backString, links } = this.props.mobileMenuItems as MobileMenuViewModel
      const { myPageLink } = this.props
      //TODO: Is this type correct?
      let arr: LinkViewModel[] = links || []

      if (arr) {
        if (backString) {
          //TODO: Is it ok to ignore this here?
          // @ts-ignore
          arr.unshift(backString) // arr expects Array<LinkViewModel>, but backString has to be a string
        }

        if (myPageLink) arr.push(myPageLink)
        this.setState({
          mobileCurrentItems: arr,
        })
      }
    }
  }

  handleToggle = () => {
    this.setState((state) => ({
      isOpen: !state.isOpen,
      currentLinksOpen: !state.isOpen,
    }))
    this.props.onCloseHeaderOverlay?.() // Close HeaderMobile overlay
  }

  handleCloseToggle = () =>
    this.setState({
      isOpen: false,
      currentLinksOpen: false,
    })
  handleBackClick = () =>
    this.setState({
      currentLinksOpen: false,
    })
  onCloseHeaderOverlay = () => {
    // Ensure the HeaderMobile overlay is closed
    this.setState((prevState) => ({
      ...prevState,
      overlayVisible: false,
      isOpen: false,
    }));
  };
  get renderBackLink() {
    const { backLink } = this.props
    if (!backLink) return null
    const backLinkEventMeta = {
      event: 'back-link',
    }

    return (
      <div className={cx(styles.backLinkHolder)}>
        <Link {...backLink} className={styles.backLink} eventMeta={backLinkEventMeta}>
          <Icon iconSrc={arrowLeft} className={styles.prevAngle} width="11px" height="11px" />
          <div>{backLink.label}</div>
        </Link>
      </div>
    )
  }

  render() {
    const {
      hide,
      logo,
      pageLogin,
      mobileMenuItems,
      serviceMenu,
      searchBtn,
      backLink,
      items,
      header,
      breakingNewsLink,
      notificationCount,
      myPageLink,
      alignLogin,
      onSubmit,
      pageLinks
    } = this.props
    const { isOpen, currentLinksOpen, mobileCurrentItems } = this.state

    if (hide !== null && hide === true) return null
    if (!mobileMenuItems) return null

    return (
      <div className={cx(styles.mobileNavigation, isOpen && styles.isOpen)}>
        <HeaderMobile
          logo={logo}
          pageLogin={pageLogin}
          onToggle={this.handleToggle}
          handleCloseToggle={this.handleCloseToggle}
          isOpen={isOpen}
          notificationCount={notificationCount}
          alignLogin={alignLogin}
          onCloseNavigationOverlay={this.onCloseHeaderOverlay} // New prop
        />

        <div
          className={cx(styles.overlay, isOpen && styles.isActive)}
          onClick={this.handleToggle}
        />

        <SideMenuMobile
          isOpen={isOpen}
          currentLinksOpen={currentLinksOpen}
          mobileCurrentItems={mobileCurrentItems}
          topLevelLinks={mobileMenuItems.topLevelLinks}
          serviceMenu={serviceMenu}
          onBackClick={this.handleBackClick}
          searchBtn={searchBtn}
          notificationCount={notificationCount}
          myPageLink={myPageLink}
          onSubmit={onSubmit}
          onCloseHeaderOverlay={this.onCloseHeaderOverlay}
          pageLinks={pageLinks}
        />


        {this.renderBackLink}
        {items && header && (
          <NewsTicker
            items={items}
            header={header}
            className={backLink ? styles.top : styles.bottom}
            breakingNewsLink={breakingNewsLink}
          />
        )}
        {backLink && <DividerComp marginTop="none" marginBot="none" noSideMargin />}
      </div>
    )
  }
}

export default NavigationMobile